export default {
  content: `아이투맥스 메시징 서비스 이용 약관

제1장 총칙

제 1 조 (목적)
본 이용약관(이하 “약관”)은 (주)아이투맥스(이하 “회사”)의 웹사이트 “아이투메시지”를 통해 제공하는 
메시징 서비스에 대한 이용조건 및 절차와 기타 필요한 제반 사항을 규정함을 목적으로 합니다.

제2조 (용어의 정의)
이 “약관”에서 사용하는 용어의 정의는 다음과 같습니다.

(1) 메시징 서비스(이하 “서비스”) : 컴퓨터 서버 또는 클라우드 컴퓨팅 환경에서 이용할 수 있도록
“회사”에서 제공하는 메시지 전송 프로그램(이하 “전송 프로그램”) 또는 메시지 전송
API(Application Program Interface, 이하 “메시지 API”)를 이용하여 유무선 통신망을 통해
단말기 또는 유무선 단말기나 서버에 메시지를 송수신하는 서비스 및 그와 관련된 부가
서비스 일체

(2) “아이투메시지” 홈페이지(https://partner.i2message.io, 이하 “홈페이지”) : “회사”가 제공하는
“전송 프로그램” 이용계약을 신청하고 전송 메시지 관련 전송통계 및 청구내역을 확인하는
웹사이트

(3) 이용고객 : 본 “약관”에 동의하고 “서비스” 이용 신청서 또는 계약서를 작성하여 “회사”의
“서비스”를 이용하기로 신청(계약)한 법인 또는 개인 사업자

(4) 전송 프로그램 : “회사”에서 직접 개발하고 배포하는 메시지 전송을 위한 SaaS형 프로그램으로
“이용고객”의 클라우드 컴퓨팅 환경에 설치하여 “회사”의 “메시지 시스템”과 연결하여
메시지를 송수신하는 프로그램

(5) “메시지 API” : “회사”에서 개발하여 배포하는 메시지 전송을 위한 통신 규약으로 “이용고객”의
서버 또는 클라우드 컴퓨팅 환경에서 “IB”의 “메시지 시스템”으로 메시지를 전송할 때
사용하는 프로토콜 및 관련 통신 규약 일체

(6) 메시지 시스템 : “회사”가 “서비스” 제공을 위하여 운영하는 하드웨어, 소프트웨어 일체

(7) 무선 통신망 : 전선을 사용하지 않고 전자기파를 이용하여 이동 전화 등이 수신할 수 있도록
  정보 전달할 수 있게 하는 통신의 설비나 조직

(8) 서비스 ID : “회사”가 제공하는 “메시지 시스템”과 “홈페이지” 접속을 위해 “이용고객”에게
부여하는 식별자

(9) 망사업자 : “서비스”의 제공을 위해 사용하는 “무선 통신망”을 운영하는 유무선 통신사업자

(10) 스팸 : “무선 통신망”을 통해 수신자의 동의 없이 일방적으로 전송되는 영리목적의 광고성
정보

(11) 불법스팸 : 정보통신망이용촉진및정보보호등에관한법률(이하 “정보통신망법”)을 위반하여
전송되는 영리목적의 광고성 정보

(12) 문자피싱 : 메시지를 통해 발생하는 전자금융사기

(13) 발신번호 : 메시지 전송 시 첨부하는 보내는 사람을 식별하는 번호(또는 회신번호)

(14) 카카오톡 : ‘다음카카오’가 운영하는 모바일 메신저 기반의 실시간 커뮤니케이션 서비스 내지
해당 서비스를 제공하는 어플리케이션

(15) 알림톡 : 국문,영문 및 특수문자 구별 없이 띄어쓰기 포함 최대 1,000자의 문자를 이동전화
번호 기반으로 ‘카카오톡’을 통해 특정 ‘수신자’에게 전달하는 서비스

(16) 친구톡 : 전화번호로 수신자를 특정하며, 수신자가 특정 발신프로필과 카카오 톡상 채널
추가한 경우에 한하여 카카오톡 메시지 발송이 가능한 메시징 서비스

(17) 템플릿 : ‘알림톡’ 발송에 반복적으로 사용되는 문구를 일정한 작성 규칙에 따라 고정적인
표현 영역과 가변적인 표현 영역으로 구분하여 표시한 것

(18) 전송자격인증제 : 전송자격인증제란 전기통신사업법 제2조제14호나목의 특수한 유형의
      부가통신역무를 제공하는 사업자가 영리 목적의 광고성 정보를 발송하는 경우 사전에
      문자중계사 또는 인증업무를 위탁받은 운영기관이 심사를 통해 인증을 부여하는 제도를
      말한다

제3조 (약관의 적용과 개정)
(1) “회사”는 본 “약관”을 “홈페이지”(https://partner.i2message.io)에 게시하는 방법으로 공지하며
“서비스” 이용 신청(계약) 시 “이용고객”으로부터 “약관”에 대한 동의를 받습니다.

(2) “회사”는 “약관의 규제에 관한 법률”, “정보통신망법”등 관련법을 위배하지 않는 범위에서 본
“약관”을 개정할 수 있습니다.

(3) “회사”가 본 “약관”을 개정하는 경우에는 적용일자 및 개정사유를 명시하여 그 적용일자 30일
이전부터 적용일자 전일까지 공지합니다.

(4) “회사”가 전항에 따라 개정 약관을 공지 또는 통지하면서 30일 기간 내에 의사 표시를 하지
않으면 의사표시가 표명된 것으로 본다는 뜻을 “이용고객”에게 명확하게 공지 또는 통지하였
음에도 “이용고객”이 명시적으로 거부의 의사표시를 하지아니한 경우 “이용고객”이 개정
약관에 동의한 것으로 봅니다.

(5) “이용고객”이 개정 약관의 적용에 동의하지 않는 경우 “회사”는 개정 약관의 내용을 적용할 수
없으며, 이 경우 “이용고객”은 계약을 해지할 수 있습니다. 다만, 기존 “약관”을 적용할 수
없는 특별한 사정이 있는 경우에는 “회사”는 이용계약을 해지할 수 있습니다.

(6) 새로운 “서비스”가 개설될 경우 별도의 명시된 설명이 없는 한 본 “약관”에 따라 제공합니다.

(7) “회사”는 “서비스”에 부수하여 타 서비스와 연계한 통합서비스 또는 별도의 서비스 등을 제공
할 수 있으며 이용조건 등은 별도로 공지하는 바에 따릅니다.
제4조 (약관 외 준칙)
(1) 본 “약관”은 “회사”가 제공하는 “서비스”에 관하여 별도의 정책 및 운영규칙과함께 적용됩니다.
(2) 본 “약관”의 해석은 대한민국 법에 의하여 해석되고 적용되며, “약관”에서 정하지 아니한
사항은 전기통신기본법, 전기통신사업법 및 기타 관계법령 또는 상관례에 따릅니다.

제5조 (개인정보취급방침의 적용)
(1) “회사”는 관계법령이 정하는 바에 따라 “서비스” 이용 신청(계약)을 위해 수집하는 “이용고객”
의 개인정보를 보호하기 위하여 노력을 합니다. 단, “이용고객”이 게시판 등 온라인상에서
자발적으로 제공하는 개인정보는 다른 사람이 수집하여 사용할 가능성이 있으며 이러한
위험은 개인에게 책임이 있고 “회사”는 책임이 없습니다.

(2) “회사”는 “회사”가 제공하는 “서비스”의 “이용고객”을 대상으로 “서비스”의 양적, 질적 향상을
위하여 “이용고객”의 개인 식별이 가능한 개인정보를 “이용고객”의 동의를 받아 수집하여
“서비스”에 이용할 수 있습니다.

(3) “회사”가 수집하는 개인정보는 “서비스”의 제공에 필요한 최소한으로 하되, 필요한 경우
자세한 정보를 요구할 수 있습니다.

(4) “회사”는 개인정보의 수집 시 관련 법규에 따라 “서비스” 이용 신청서 또는 계약서 및 “약관”
에 그 수집 범위 및 목적을 사전 고지하며 “회사”의 “개인정보취급방침”
(https://partner.i2message.io/privact)에 공개합니다.

(5) “이용고객”이 제공한 개인정보는 “이용고객”의 동의 없이 제3자에게 누설하거나 제공하지
않습니다.

(6) 회사 내부 방침에 의한 정보보유 사유
가. 부정이용기록
- 보존 이유: 부정 이용 방지
- 보존 기간: 1년

(7) 관련법령에 의한 정보보유 사유
상법, 전자상거래 등에서의 소비자보호에 관한 법률 등 관계법령의 규정에 의하여보존할 필요
가 있는 경우 회사는 관계법령에서 정한 일정한 기간 동안 회원정보를 보관합니다. 이 경우
회사는 보관하는 정보를 그 보관의 목적으로만 이용하며 보존기간은 아래와 같습니다.`,
  table: [
    '보존 근거',
    '보존 내용',
    '보존기간',
    '전자상거래 등에서 소비자보호에 관한 법률',
    '계약 또는 청약철회 등에 관한 기록',
    '5년',
    '대금 결제 및 재화 등의 공급에 관한 기록',
    '5년',
    '소비자 불만 또는 분쟁 처리에 관한 기록',
    '3년',
    '통신비밀보호법',
    '웹사이트 방문에 관한 기록',
    '3개월',
    '핸드폰번호, 문자 전문 등을 포함한 통신이력',
    '3개월',
    `문자전문을 제외한 핸드폰 번호등을 포함한 통신이력
  (시외/시내전화역무와 관련된 자료)`,
    '6개월',
  ],
  content2: `제2장 서비스 이용

제6조 (이용 단위 및 기간)
(1) “서비스” 이용계약의 단위는 “이용고객”당 1개의 “서비스 ID” 단위로 체결하는 것을 원칙으로
합니다. 다만, “회사”가 인정하는 경우에 2개 이상의 “서비스 ID”도 제공할 수 있습니다.

(2) “회사”는 “서비스” 이용 신청(계약)에 대한 승낙 후 신청(계약)한 “서비스 ID”로 접속 권한을
부여한 시점부터 “서비스”를 제공하며 “서비스”에 대한 이용 기간은 가입일로부터 1년으로
합니다.

제7조 (이용 신청 및 계약)
(1) “서비스”를 이용하고자 하는 고객은 본 “약관”, “개인정보 수집 및 이용”, “스팸 메시지 관리
규정”에 동의하고 이용 신청서 또는 계약서를 제출하여 신청할 수 있습니다.

(2) “서비스” 이용 신청(계약)은 “회사”가 “이용고객”이 제출한 구비 서류와 기타 자격 조건을 확인
하고 이용 신청(계약)을 승인하여 “서비스” 제공 개시일과 “서비스 ID” 등 기타 필요한 사항을
“이용고객”에게 통지함으로써 체결됩니다.

(3) “서비스”를 이용하고자 하는 고객은 다음 각 호의 서류를 직접 또는 우편이나 “회사”가
인정하는 방식으로 제출하여야 합니다.
1 법인 또는 개인 인감 날인한 “서비스” 이용 신청서 또는 계약서(“홈페이지”에서 출력 가능)
2 스팸메시지 관리 규정 동의서 (“홈페이지”에서 출력 가능)
3 개인정보 수집 및 이용 동의서 (“홈페이지”에서 출력 가능)
4 월 예상 이용 금액이 부가세 포함 삼백만 원 이상인 경우 본 계약의 계약기간을 보증 기간으로
하고, 월 이용금액의 3배에 해당하는 금액을 담보하는 이행(지급)보증보험증권 (이하, “증권”)
5 사업자등록증 사본
6 문자재판매사업자는 전송자격인증서 사본
7 기타 “회사”가 “이용고객”에게 요청하는 서류 (필요 시)

(4) “회사”는 상장사 또는 신용등급 BBB- 이상, 공공기관은 동조 3항4호의 “증권”을 받지 않습니다.

(5) “회사”는 고객의 업종, 이용 형태 등에 따라 별도의 동의서를 요구하거나 부속계약서를 체결할
수 있으며 이를 위하여 고객의 개인정보를 이용할 수 있습니다.

(6) “회사”는 “스팸”, “불법스팸” 및 “문자피싱” 발송 등으로 “서비스” 계약을 해지한 고객의 “서비스”
이용 신청(계약)에 대한 승낙을 유보하기 위하여 법인명, 대표자명, 사업자 등록번호,
전화번호, 해지사유 등의 정보를 수집, 보관할 수 있습니다.

(7) “서비스” 이용을 위하여 “이용고객”은 “이용고객” 본인의 명의를 증명할 수 있는 발신번호를
서비스 이용 전에 등록하여야 합니다. 본인 명의(또는 실명)의 발신번호를 사전에 등록하지
않은 “이용고객”은 법적인 보호를 받을 수 없으며, 서비스 이용의 제한을 받을 수 있습니다.

제8조 (이용 신청의 승인 및 거부)
(1) “회사”는 “서비스”의 이용을 요청한 고객에 대하여 업무 수행상 또는 기술상 지장이 없는 경우
에는 접수 순서에 따라 “서비스” 이용을 승낙합니다.

(2) “회사”는 다음 각 호에 해당되는 사항의 경우 이용 신청(계약)에 대한 승낙을 일정기간
유보하거나 거부할 수 있습니다.
1 “스팸”, “불법스팸” 및 “문자피싱” 메시지를 다량 전송할 소지가 있다고 판단되는 경우
2 “이용고객”의 정확한 신원, 메시지 전송권한 등이 확인되지 않는 경우
3 “이용고객”이 실명이 아니거나, 제3자 또는 법인의 명의 사용 등 필수 제출 정보를 허위로 제공
또는 누락, 오기하여 신청(계약)한 경우
4 “망사업자”의 송부 제한이 있는 경우
5 “회사”가 제공하는 모든 “서비스” 또는 시스템 중 어느 하나에 대하여 계약 해지를 당한 이후
1년이 경과하지 않은 경우
6 “이용고객” 본인 명의를 증명할 수 있는 발신번호를 사전에 등록하지 않는 경우
7 “이용고객”이 문자재판매사업자이나 전송자격인증제에 따른 인증(이하 ‘전송자격인증’)을 받지
않거나, 인증이 취소된 사업자인 경우

(3)“회사”는 “이용고객”이 전항의 사유를 소명하고 이를 입증한 이후 1개월 이내에 이용 신청(계약)
에 대한 승낙을 할 수 있습니다.

제9조 (회사의 의무)
(1) “회사”는 특별한 사정이 없는 한 “이용고객”이 신청(계약)한 “서비스” 이용 희망일에 “서비스”를
이용할 수 있도록 합니다.

(2) “회사”는 계속적, 안정적으로 “서비스”를 제공할 의무가 있으며 “메시지 시스템”이 최상의 상태
를 유지하도록 관리하며 전송 데이터의 보안을 위해 최선을 다합니다.

(3) “회사”는 “메시지 시스템” 또는 “서비스” 제공을 위한 시스템에 장애가 발생하거나 또는 고장
발생 시 그 사실을 전화, 메일 등 신속한 방법으로 “이용고객”에게 전달하고 복구를 위하여
최선의 조치를 강구합니다. 다만, 천재지변, 비상사태 또는 그 밖의 부득이한 경우에는
“서비스”를 일시 중단하거나 중지할 수 있습니다.

(4) “회사”는 “서비스” 제공과 관련하여 취득한 “이용고객”의 정보를 본인의 승낙 없이 타인에게
누설 또는 배포할 수 없으며 상업적 목적으로 사용할 수 없습니다. 다만, 관계법령에 의한
관계기관으로부터의 요청 등 법률의 규정에 따른 적법한 절차에 의한 경우 또는 “회사”가
정한 기간 동안 이용요금을 체납하여 “이용고객”의 동의를 얻어 신용정보사업자 또는
신용정보집중기관에 제공하는 경우에는 그러하지 않습니다.

(5) “회사”는 “이용고객”이 “서비스” 제공 목적에 맞는 이용 여부를 확인하기 위하여 상시적으로
모니터링을 실시하며, “스팸”, “불법스팸” 및 “문자피싱”을 전송한 사실을 확인한 경우 한국
인터넷진흥원 불법스팸대응센터에 관련 자료를 첨부하여 신고할 수 있습니다.

(6) “회사”는 계약의 체결, 계약 사항의 변경 및 해지 등 “이용고객”의 “서비스” 이용 절차에 있어
“이용고객”에게 편의를 제공하기 위해 노력합니다.

(7) “회사”는 의도적으로 발신번호를 변작한 메시지 또는 사전에 등록하지 않은 발신번호를
사용한 메시지의 전송을 차단할 수 있습니다.

(8) “회사” 사용자 원할한 사용을 위해 서비스 유지관리하며, 장애(통신장애, 시스템 장애 등)
장애 발생 시 24시간 내 조치한다. 단 24시간 내 조치가 불가할 경우 고객에게 복구가능시기
를 알린다.

(9) “회사”는 “이용고객”중 문자재판매사업자가 전송자격인증이 취소된 사실을 알게되는 경우
서비스 정지, 계약 해지 등의 조치를 취할 수 있다. 

제10조 (이용고객의 의무)
(1) “이용고객”은 “서비스” 이용 신청서 또는 계약서에서 정한 요금을 납입할 의무가 있습니다.

(2) “이용고객”은 “회사”가 제공하는 “전송 프로그램”, “서비스”의 모든 정보 및 “회사”의 기술 권한
에 대해 “회사”의 승인 없이 복사, 복제, 수정, 번역하여 제3자에게 배포할 수 없습니다.

(3) “이용고객”은 “서비스” 계약에 필요한 개인신상정보 등을 “회사”에 허위로 제공하여서는 아니
되며, 정보변경 시 지체없이 “회사”에 통보하여 갱신하여야 합니다.

(4) “이용고객”은 “서비스”의 본래 목적 외의 용도로 “서비스”를 이용하여서는 아니되며 타인의
지적재산권 또는 타인이 사생활을 침해하는 내용을 전송할 목적으로 사용해선 안 되고 제3자
에게 임의로 해당 “서비스”를 임대하여서도 안 됩니다.

(5) “이용고객”은 “정보통신망법”에 따른 광고성 정보 전송 시 의무사항 및 “회사”의 “약관”을 준수
하여야 하며, 기타 “회사”의 업무 수행에 현저한 지장을 초래하는 행위를 하여서는 안 됩니다.

(6) “이용고객”은 공공의 안녕, 질서 또는 미풍양속을 해하는 다음 각 호의 내용으로 메시지를
전송하여서는 안 됩니다.
1 범죄 행위를 목적으로 하거나 범죄 행위를 교사하는 내용
2 반국가적 행위의 수행을 목적으로 하는 내용
3 선량한 풍속, 기타 사회질서를 해하는 내용

(7) “이용고객”은 “정보통신망법”에 따라 메시지 전송을 위해 이동통신사 가입자의사전 수신동의를
직접 얻어야 하고, “스팸”, “불법스팸” 및 “문자피싱” 전송을 위해 “서비스”를 이용하여서는
아니 되며, “회사”를 통해 전달되는 수신거부 요청에 대해서는 즉각적으로 처리하고 24시간
이내에 처리결과를 “회사”에 회신하여야 하며 본 항의 위반으로 발생하는 모든 민 형사상의
책임은 “이용고객”이 직접 부담해야 합니다.

(8) “이용고객”은 “전기통신사업법” 제84조의2(전화번호의 거짓표시 금지 및 이용자 보호)에 의거
발신번호를 사전에 등록하고 등록한 번호로만 문자를 발송하여야 합니다.

(9) “이용고객”은 다음 각 호의 1에 해당하는 경우에는 “회사”의 요구에 따라 월 이용 요금의 3배
에 해당하는 금액을 보험가입금액으로 하는 “증권”을 제출하여야 합니다.
1 “서비스” 이용 신청(계약)시 1개월 이용요금이 부가세포함 삼백만 원 이상이 예상되는 경우
2 “서비스” 이용 중에 특정월의 이용 요금이 부가세포함 삼백만 원 이상이 되는 경우

(10) “이용고객”은 보증기간 만료 후에도 보증기간 내 발생시킨 “서비스”와 관련된 채무에 대한
손해 배상이 가능한 특별약관에 가입한 “증권”을 제출하여야 합니다.

(11) ”회사”는 “이용고객”이 “증권”을 제출하였더라도 월 이용 요금이 “증권” 가입 금액의 2/3를
초과하게 될 경우 “증권” 가입 금액에 대한 증액을 요청할 수 있으며, “이용고객”이 증액을
거부할 경우 “회사”는 “서비스” 제공을 제한할 수 있습니다.

(12) “이용고객”은 “증권”이 만료되기 7일전까지 기간을 연장하여 제출해야 하며 이 때도 상기 9항
    과 10항의 조건을 준용하여야 합니다.

(13) “이용고객”중 문자재판매사업자는 전송자격인증을 받고 전송자격인증제 운영규정을 준수해야
한다.

제11조 (이용 제한)
(1) “회사”는 국가비상사태, “서비스” 설비의 장애 또는 “서비스” 이용의 폭주 등으로 “서비스” 이용
에 지장이 있는 때에는 “서비스”의 전부 또는 일부를 제한하거나 정지할 수 있습니다.

(2) “서비스”의 원활한 운영을 위하여 “이용고객”이 전송하는 메시지에 대해 일별 또는 월별 전송
허용 건수 및 전송 시간 등을 제한할 수 있으며 개별 메시지에 대한 재전송 횟수를 한정할
수 있습니다.

(3) “회사”는 “이용고객”의 “서비스” 이용 내용이 다음 각 호에 해당하는 경우 “서비스” 이용을
30일 이내의 기간을 정해 제한할 수 있으며, 제한 사유에 대한 소명이 이뤄진 후 서비스
문제가 없다고 판단될 경우 재개할 수 있습니다.
1 제10조 규정에 의한 “이용고객”의 의무를 이행하지 않은 경우
2 “이용고객”이 서비스월(M)의 익월인 청구월(M+1) 기준 2개월 이상 요금을 미납한 경우
3 “회사”에 납부할 “서비스” 이용 금액(미납요금과 미청구 금액)이 담보한 보증금액을 초과한 경우
4 “서비스”의 안정적 운영을 방해할 목적으로 다량의 정보를 전송하거나 수신자의 의사에 반하여
광고성 정보를 지속적으로 전송하는 경우
5 다른 “이용고객” 또는 제3자의 지적재산권을 침해하는 경우
6 방송통신심의위원회의 시정요구가 있거나 불법선거운동과 관련하여 중앙선거관리위원회의
유권해석을 받은 경우
7 타 “이용고객”의 “서비스 ID”를 부정하게 이용하거나 타인의 명예를 손상시키거나 불이익을
주는 경우
8 “서비스” 정보를 이용하여 얻은 정보를 “회사”의 사전 승낙 없이 복제 또는 유통시키거나
상업적으로 이용하는 경우
9 “서비스”에 위해를 가하거나 “서비스”의 건전한 이용을 저해하는 경우
10 타인의 명의를 이용하여 신청(계약)한 경우 또는 신청서 또는 계약서의 내용을 허위로
기재하였거나 허위서류를 첨부하여 “서비스”의 이용승낙을 득한 경우
11 국익 또는 사회적 공익을 저해할 목적으로 이용되는 경우
12 메시지 수신자가 “스팸”으로 신고하거나 “이용고객”이 발송하는 메시지가 “불법스팸”임이 판명
    될 경우
13 방송통신위원회∙과학기술정보통신부∙한국인터넷진흥원 등 관계기관이 “스팸”, “불법스팸”, “문자
피싱” 또는 의도적으로 발신번호를 변작한 문자의 전송 사실을 확인하여 이용정지를
요청하는 경우
14 “전기통신사업법” 제22조의3(특수한 유형의 부가통신사업의 기술적 조치 등) 및 제84조의2
(전화번호의 거짓표시 금지 및 이용자 보호)에 근거한 의무를 이행하지 않은 경우

(4) “회사”는 "증권" 제출 대상에 해당하지 않는 경우에도 “서비스” 이용 금액에 대한 월간 기본
한도인 부가세 포함 삼백만원을 부여하며 해당 한도를 초과하는 경우
“서비스”의 이용을 제한할 수 있습니다.

(5) “회사”는 상기 3항 2호의 경우, 청구 익익월(M+3) 1일 부로 “서비스” 이용을 제한 및 정지할
수 있으며 신용정보회사로 추심을 이관할 수 있습니다.

(6) “회사”는 상기 3항 12호 내지 14호의 경우 “이용고객”에게 전송량 축소, “서비스 ID”수 축소,
“서비스 ID” 중지 등의 방법으로 “서비스” 이용을 제한할 수 있습니다.

(7) “회사”는 과학기술정보통신부(거짓으로 표시된 전화번호로 인한 이용자 피해예방에 관한) 고시
제2015-32호 제10조 및 세부지침 제19조에 따라 “이용고객”의 “서비스”를 최대 3개월간 중지
할 수 있습니다. 단, 악의적인 목적 없이 “이용고객”의 실수로 인해 변작된 경우 “이용고객”의
소명을 받고 심사 후 서비스를 재개할수 있습니다.

(8) “회사”는 전기통신사업법에 따라 “서비스” 또는 사업의 전부 또는 일부를 휴지하거나 폐지하려
는 경우에는 그 휴지 또는 폐지 예정일 30일 전까지 그 내용을 “이용고객”에게 알리고
과학기술정보통신부장관에게 신고하며, 이 경우 1년 이상 계속하여 “서비스” 또는 사업을
휴지하지 아니합니다.

제12조 (이용고객의 책임)
(1) “서비스 ID” 및 비밀번호의 관리와 이용은 “이용고객”의 책임으로 합니다.

(2) “서비스 ID”는 다음 각 호의 1에 해당하는 경우에는 “회사”의 요청에 의하여 변경할 수 있습니다.
1 “서비스 ID”가 “이용고객”의 전화번호 또는 사업자 등록번호 등으로 되어 있어 사생활 침해가
 우려되는 경우
2 타인에게 혐오감을 주거나 미풍양속에 어긋나는 경우
3 기타 합리적인 사유가 있는 경우

(3) “이용고객”에게 통보된 “서비스 ID” 또는 비밀번호에 의하여 발생되는 사용상의 과실 또는
제3자에 의한 부정사용 등에 대한 모든 책임은 “이용고객”에게 있습니다. 다만, “회사”의
고의 또는 중과실이 있는 경우에는 그러하지 아니합니다.

(4) “이용고객”은 메시지 발송을 위해 “이용고객”이 운영하는 어플리케이션, 웹서버, DB서버,
네트워크 등에 대한 관리 책임을 지며 “이용고객”의 관리 소홀 또는 시스템 취약점 등 “이용
고객”의 귀책사유가 있는 사정에 의한 해킹 또는 불법 침해로 인해 발생되는 다량의 메시지
발송, “서비스” 장애, “서비스” 중단, “스팸”, “불법스팸”, “문자피싱” 발송, 그로 인한 이용 요금
등의 피해에 대해서는 “회사”가 책임지지 않습니다.

제13조 (이용요금의 청구 및 납부)
(1) “회사”는 이용 요금 정산을 위하여 메시지 전송 건수에 대한 통계를 작성, 관리하고 월별 청구
내역에 대해 서비스월(M)의 익월(M+1) 10일까지 사용월 익월(M+1) 5일자로 청구합니다.

(2) “이용고객”은 “서비스” 이용 신청(계약) 시 선택한 납부 방법으로 사용익월(M+1) 28일까지
이용 요금을 납부하여야 합니다.

(3) “회사”는 요금에 따라 익월에 합산 청구하거나 일정액 이하의 소액요금의 경우에는 누적하여
청구할 수 있습니다.

(4) “회사”는 미납금을 최근 청구 월 요금에 합산하여 청구할 수 있습니다.

제14조 (이용계약의 갱신)
이용 기간 만료 1개월 전까지 별도의 협의가 없는 경우 “이용고객” 또는 “회사”의 특별한 의사표
시가 있을 때까지 이전의 이용계약과 동일한 조건으로 “서비스” 이용 기간이 자동으로 1년 연장
됩니다.

제15조 (이용계약의 해제 또는 해지)
(1) “이용고객”이 “서비스” 제공 개시 전에 계약을 해제하고자 하거나 “서비스” 제공개시 후에
이용계약을 해지하고자 할 때에는 해제 또는 해지하고자 하는 날의 5일 전까지 이용계약
해제 또는 해지를 “회사”에 통보해야 합니다.

(2) “회사”는 제1항의 규정에 의하여 해지신청이 접수되면 “이용고객”이 요청한 해지일로부터
“서비스” 이용을 제한합니다. 이 경우 “이용고객”은 이용이 제한된 날까지의 요금을 완납하여
야 합니다.

(3) “회사”는 “이용고객”이 다음 중 하나에 해당함에도 불구하고 제한사유를 해소하지 않거나, 
정당한 사유 없이 의견진술에 응하지 않은 경우에는 지체 없이 이용계약을 해지 또는 해제할
수 있으며, 그 사실을 “이용고객”에게 통지합니다. 다만 미리 통지하는 것이 곤란한 경우에는
선 조치 후 통지할 수 있습니다.
1 제11조 제3항 규정에 따른 “서비스” 이용제한사항을 위반한 경우
2 당해 연도에 2회 이상 이용정지를 당한 경우
3 “서비스” 제공 목적 외의 용도로 “서비스”를 이용하거나 제3자에게 임의로 해당 “서비스”를
 임대한 경우

(4) 제3항에 의해 해제, 해지된 “이용고객”에 대하여는 귀책사유가 해소될 때까지 이용 신청(계약)
을 거부할 수 있으며, 이용 신청(계약)에 대한 승낙을 유보하기 위하여 법인명, 대표자명,
사업자 등록번호, 전화번호, 해지사유 등의 정보를 1년간 보관할 수 있습니다.

제16조. (이용자 불만 유형별 처리절차 및 처리기간)
(1) 서비스 품질 불만 전화접수 48시간 이내

(2) 시스템 장애 전화접수 12시간 이내

(3) 요금 과•오납 팩스,서면 및 전화접수 7일 이내

제3장 손해배상 및 기타사항

제17조 (손해배상의 범위 및 면책)
(1) “회사”는 다음 각호의 1의 사유를 입증하는 경우에는 요금 감면 책임 또는 손해배상 책임이
감면될 수 있습니다.
1 전시.사변.천재지변 또는 이에 준하는 국가 비상사태 등 불가항력으로 인한 경우
2 “이용고객”의 고의 또는 과실로 인하여 발생한 경우
3 전기통신서비스의 특성상 불가피한 사유로 “서비스” 제공이 불가능한 경우
4 “무선 통신망” 또는 “망사업자”의 장애인 경우

(2) “이용고객”으로부터 제공된 정보의 하자 또는 “서비스”에 의해 전송된 메시지 및 정보에 의해
발생한 “이용고객” 또는 제3자의 손해에 대해서는 “회사”는 일체의 책임을 지지 않습니다.

(3) “이용고객”이 “회사”의 “서비스” 제공으로부터 기대되는 이익을 얻지 못하였거나 “서비스”로
부터 수반되는 잠재가치 및 “서비스” 자료에 대한 취사선택 또는 이용으로 발생하는 손해
등에 대해서는 책임이 면제됩니다.

(4) “회사”는 “이용고객”의 귀책사유로 인하여 “서비스” 이용의 장애가 발생한 경우에는 책임이
면제됩니다.

(5) “회사”는 “이용고객”과 제3자 상호간에 “서비스”를 매개로 발생한 분쟁에 대해 개입할 의무가
없으며 이로 인한 손해를 배상할 책임이 없습니다.

(6) “정보통신망법”에서 규정한 사항을 위반하여 발생한 손해에 대한 책임은 “회사”에서 책임지지
않습니다. 또한 “회사”가 물질적, 정신적 손해를 입을 경우 “이용고객”은 “회사”가 입은 손해
에 대한 배상 책임 의무가 있습니다.

(7) “회사”는 제11조에 의거 “이용고객”의 “서비스” 이용을 제한하는 경우 이로 인해 발생할 수
있는 “이용고객”의 손해 등에 대해서는 책임이 면제됩니다.

(8) “이용고객”이 “서비스”를 통해 전송한 메시지 및 정보에 의해 “회사”가 메시지 수신자 또는
제3자로부터 소송 등 이의제기를 받는 경우 “이용고객”은 “회사”를 면책하여야 하며,
그럼에도 불구하고 “회사”가 면책되지 못하는 경우에는 “이용고객”은 이로 인한 “회사”의
모든 손해를 배상해야 합니다.

제18조 (기타)
(1) “회사”와 “이용고객”간의 통신은 서면, 전자우편, 팩스 등으로 합니다.
(2) 분쟁으로 소송이 제기될 경우, 대한민국 서울지방법원을 관할법원으로 합니다.

부칙
(1) 본 “약관”은 2025년 3월 4일부터 시행됩니다.
(2) 2020년 5월 27일부터 시행되던 종전의 “약관”은 본 “약관”으로 대체합니다.`,
};
